export default "__VITE_ASSET__DW0BlHuD__"